<div class="modal-overlay" *ngIf="isVisible" (@fadeInOut.start)="animationHandler($event)" (@fadeInOut.done)="animationHandler($event)">
  <div class="modal-content" (@slideIn.start)="animationHandler($event)" (@slideIn.done)="animationHandler($event)">
    <button class="close-btn" (click)="closeModal()">✕</button>
    <h2 class="modal-title">Votre avis compte !</h2>
    <p class="intro-text">Partagez vos impressions pour nous aider à améliorer l’expérience.</p>

    <form [formGroup]="evaluationForm" (ngSubmit)="submitEvaluation()" class="evaluation-form">
      <!-- Note générale -->
      <div class="form-group">
        <label>Comment évaluez-vous l'application ?</label>
        <div class="stars">
          <span *ngFor="let star of [1, 2, 3, 4, 5]"
                (click)="setRating(star)"
                (mouseover)="hoverRating(star)"
                (mouseleave)="resetHover()"
                [class.filled]="rating >= star"
                [class.hover]="tempRating >= star"
                [@starPulse]="rating >= star ? 'pulsing' : 'idle'">★</span>
        </div>
      </div>

      <!-- Facilité d'utilisation -->
      <div class="form-group">
        <label>L'application est-elle facile à utiliser ?</label>
        <div class="radio-group">
          <button type="button"
                  (click)="evaluationForm.patchValue({ easeOfUse: 'yes' })"
                  [class.selected]="evaluationForm.get('easeOfUse')?.value === 'yes'"
                  [@checkPulse]="evaluationForm.get('easeOfUse')?.value === 'yes' ? 'checked' : 'unchecked'">
            Oui
          </button>
          <button type="button"
                  (click)="evaluationForm.patchValue({ easeOfUse: 'no' })"
                  [class.selected]="evaluationForm.get('easeOfUse')?.value === 'no'"
                  [@checkPulse]="evaluationForm.get('easeOfUse')?.value === 'no' ? 'checked' : 'unchecked'">
            Non
          </button>
        </div>
        <textarea formControlName="easeComment"
                  placeholder="Pourquoi ? (facultatif)"
                  class="textarea-field"
                  [@fadeIn]="evaluationForm.get('easeOfUse')?.value ? 'visible' : 'hidden'"></textarea>
      </div>

      <!-- Fonctionnalité préférée -->
      <div class="form-group">
        <label>Quelle fonctionnalité préférez-vous ?</label>
        <input type="text" formControlName="favoriteFeature" class="text-field" placeholder="Ex. : tableau de bord">
      </div>

      <!-- Suggestions -->
      <div class="form-group">
        <label>Une suggestion pour nous améliorer ?</label>
        <textarea formControlName="suggestions"
                  placeholder="Vos idées ici (facultatif)"
                  class="textarea-field"
                  (focus)="suggestionsVisible = true"
                  (blur)="suggestionsVisible = false"
                  [@fadeIn]="suggestionsVisible ? 'visible' : 'hidden'"></textarea>
      </div>

      <!-- Boutons -->
      <div class="button-group">
        <button type="submit" [disabled]="rating === 0" class="submit-btn">
          Envoyer <span class="send-icon">➤</span>
        </button>
        <button type="button" (click)="closeModal()" class="close-btn-secondary">Fermer</button>
      </div>
    </form>

    <!-- Confirmation -->
    <div class="success-overlay" *ngIf="isSubmitted" [@confettiAnimation]="'active'">
      <span class="success-icon">✔</span>
      <p>Merci pour votre retour !</p>
    </div>
  </div>
</div>